module.exports = __webpack_public_path__ + "static/media/4e03eca221e55215a37808be1886f9f3.ff9bd208.png";